import { create } from 'zustand';

/* 
	this is for product/policy selection screens
	- One policy => go back Dashboard
	- One product & multiple policy => go back to Policy's selection
	- Multiple product => go back to Prodct's selection
*/

export const useProductNavigationStore = create((set, get) => ({
  lastPage: '',
  actualPage: '',
  goBackTo: '',
  clientType: '',

  constants: {
    SINGLE_POLICY: 'single-policy',
    POLICY_LIST: 'policy-list',
    MULTI_PRODUCT: 'multi-product',
    POLICY_INFO: 'policy-info',
  },

  isMultiProduct: false,
  setIsMultiProduct: (value) => set({ isMultiProduct: value }),

  savedProducts: [],
  setSavedProducts: (value) => {
    if (
      value?.length >= 1 &&
      get().clientType === get().constants.MULTI_PRODUCT
    )
      set((state) => ({ savedProducts: [...state.savedProducts, value] }));
  },

  navigateBackFrom: (value) => {
    if (value === get().constants.POLICY_INFO) {
      if (get().clientType === get().constants.MULTI_PRODUCT)
        set({ isMultiProduct: true });
      set({ lastPage: null });
      set({ actualPage: null });
    }

    if (value === get().constants.POLICY_LIST) {
      if (!get().lastPage) {
        set({ actualPage: null });
        set({ lastPage: null });
      } else {
        if (get().lastPage === get().constants.MULTI_PRODUCT) {
          set({ isMultiProduct: true });
        }
        set({ actualPage: null });
        set({ lastPage: null });
      }
    }

    if (value === get().constants.MULTI_PRODUCT) {
      set({ actualPage: null });
      set({ lastPage: null });
    }
  },

  setActualPage: (value) => set({ actualPage: value }),
  setLastPage: (value) => {
    set({ lastPage: value });
  },

  setClientType: (policies, products) => {
    // set({ clientType: value });
    if (policies.length === 1)
      set({ clientType: get().constants.SINGLE_POLICY });
    if (products.length === 1 && policies?.pages?.flat().length > 1)
      set({ clientType: get().constants.POLICY_LIST });
    if (products.length > 1) set({ clientType: get().constants.MULTI_PRODUCT });
  },

  setLastPageVisited: (newPage) => {
    set({ actualPage: !get().actualPage ? newPage : get().actualPage });
    set({
      lastPage:
        newPage !== get().actualPage ? get().actualPage : get().lastPage,
    });
    set({
      actualPage: newPage !== get().actualPage ? newPage : get().actualPage,
    });
  },
}));
